import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Group, Stack, Text } from "@mantine/core";
import { ImageWithPlaceholder } from "../ImageWithPlaceholder";
export const UserMenuItem = ({ imageUrl, name, email }) => {
    return (_jsxs(Group, { gap: "sm", wrap: "nowrap", children: [_jsx(ImageWithPlaceholder, { imageUrl: imageUrl, avatarText: name, size: 32 }), _jsxs(Stack, { gap: 2, children: [_jsx(Text, { variant: "body", size: "sm", fw: 500, children: name }), _jsx(Text, { variant: "meta-muted", children: email })] })] }));
};
